module.exports = __webpack_public_path__ + "static/media/whiteFourSquaresIcon.08021b03.svg";